const Algorithms = {
  [null]: {
    name: 'None',
    description: 'Products in an order determiend entirely by boosts and filters',
  },
  viewedThisViewedThat: {
    name: 'Viewed This Viewed That',
    description: 'Products that are most often viewed (by other users) after viewing the given product',
    allowedScopes: ['web'],
  },
  viewedThisBoughtThat: {
    name: 'Viewed This Bought That',
    description: 'Products that are most often bought by users who viewed the current item',
    allowedScopes: ['web'],
  },
  boughtThisBoughtThat: {
    name: 'Bought This Bought That',
    description: 'Products which are frequently purchased together with the product customer has added to their cart',
    allowedScopes: ['web'],
  },
  boughtThisBoughtThatWithCategoryCoocurrence: {
    name: 'Bought This Bought That with Category Coocurrence',
    description:
      'Products which are from the categories frequently purchased together with the item customer is looking at.',
    allowedScopes: ['web'],
  },
  recommendedForYou: {
    name: 'Recommended for You',
    description:
      'Personalized recommendations based on customer behavior on the website, what products they have interacted with and how other users interact with these products i.e. views and adding to cart, purchases.',
  },
  recommendedForYouBasedOnViews: {
    name: 'Recommended for You based on Views',
    description: 'Personalized recommendations based on customer behavior on the website limited only to views.',
  },
  browsingHistory: {
    name: 'Browsing History',
    description: 'Products that customer has viewed ordered from most recently viewed to least recently viewed.',
  },
  wishlistHistory: {
    name: 'Wishlist History',
    description: 'Products that the customer has added to their wishlist',
  },
  currentWishlistProducts: {
    name: 'Wishlist Products',
    description: "Products that are currently in the customer's wishlist",
  },
  lastCartProducts: {
    name: 'Last Cart Products',
    description: 'Products which customers had in their previous cart',
  },
  currentCartProducts: {
    name: 'Current Cart Products',
    description: 'Products which customers currently have in their carts.',
  },
  popularCartProducts: {
    name: 'Popular Cart Products',
    description: 'Products which are frequently added to cart across by the given user.',
  },
  highfreqCartProducts: {
    name: 'High Frequency Purchased Products',
    description: 'Personalized recommendations based on products that the customer usually buys.',
  },
  inCartPersonlization: {
    name: 'In-Cart Personalised Recommender',
    description:
      'Personalized recommendations that returns items the user usually buys but have not been bought in the last couple of baskets.',
  },
  popular: {
    name: 'Popular Products',
    description: 'Popular products which customers view, search and purchase often.',
    allowedScopes: ['web', 'marketingChannels', 'ads'],
  },
  popularByViews: {
    name: 'Most Viewed Products',
    description: 'Products that are frequently viewed',
    allowedScopes: ['web', 'marketingChannels', 'ads'],
  },
  popularByCartAdds: {
    name: 'Top Converting Products',
    description: 'Products that are frequeenlty added to cart',
    allowedScopes: ['web', 'marketingChannels', 'ads'],
  },
  trending: {
    name: 'Trending Products (Recently Popular)',
    description: 'Products ranked by the increase in their popularity (first derivative of popularity)',
    allowedScopes: ['web', 'marketingChannels', 'ads'],
  },
  hot: {
    name: 'Hot Products (Very Recently Popular)',
    description: 'Products ranked by the rate of increase in their popularity (second derivative of popularity)',
    allowedScopes: ['web', 'marketingChannels', 'ads'],
  },
  revenueForPeriod: {
    name: 'Best Selling Products by Revenue (Last 30 Days)',
    description: 'Products that have generated the most revenue',
  },
  purchasesForPeriod: {
    name: 'Best Selling Products by Purchases (Last 30 Days)',
    description: 'Products that have generated the most revenue',
  },
  purchasesOnDiscount: {
    name: 'Best Selling Products With Discount (Last 30 Days)',
    description: 'Products that have been bought thanks to discounts',
  },
  productViewsNoCartAdds: {
    name: 'Most Viewed Products Without Card Adds (Last 30 Days)',
    description: 'Products that have gathered significant views without being added to carts',
  },
  productViewsNoCheckouts: {
    name: 'Most Viewed Products Without Purchases (Last 30 Days)',
    description: 'Products that haven’t been purchased yet but have gathered attention through views',
  },
  cartAddsNoCheckouts: {
    name: 'Added to Cart Without Purchase (Last 30 Days)',
    description:
      'Products that shoppers have shown interest in by adding them to the cart but haven’t gone on to purchase',
  },
  productViewsOutOfStock: {
    name: 'Most Viewed Products That Were Out of Stock (Last 30 Days)',
    description:
      'highly viewed products that were unfortunately out of stock at the time, indicating potential unmet demand',
  },
  new: {
    name: 'New Products',
    description: 'Products marked as New in your store in order to spike the interest of returning customers',
  },
  lastSearchNewProducts: {
    name: 'Last Search New Products',
    description: 'Products marked as New in your store and match the latest search criteria of the user',
    allowedScopes: ['marketingChannels'],
  },
  lastSearchProducts: {
    name: 'Last Search Products',
    description: 'Rersonalized recommender that returns popular products re-ordered based on user search preferences.',
    allowedScopes: ['marketingChannels'],
  },
  triggerEventProducts: {
    name: 'Products from trigger event',
    description: 'Products that appear in the chosen trigger event. This should be used with triggered campaigns only.',
    allowedScopes: ['marketingChannels'],
  },
  latestEventProducts: {
    name: 'Products from latest event',
    description:
      'Products that were part of the latest event of a configured type (e.g. product view, cart update, cart checkout success, or any custom event you send to Releva)',
    allowedScopes: ['marketingChannels'],
  },
  nextBasketPredictionEngagementOptimized: {
    name: 'Deep AI - Optimize Engagement',
    description: "Products that will catch the user's interest and increase their engagement",
  },
  nextBasketPredictionBalanced: {
    name: 'Deep AI - Balanced',
    description: 'Products that the user would probably like to view or purchase',
  },
  nextBasketPredictionConversion: {
    name: 'Deep AI - Optimize Conversions',
    description: 'Products that the user would probably like to purchase',
  },
  nextBasketPredictionBundle: {
    name: 'Deep AI - Bundles',
    description: 'Products that can be bundled to products which the user has viewed or added to cart',
  },
  nextBasketPredictionCrossSell: {
    name: 'Deep AI - Cross-sell Bundles',
    description: 'Products that can be bundled optimized for cross-sell',
    allowedScopes: ['marketingChannels'],
  },
  nextBasketPredictionUpsell: {
    name: 'Deep AI - Up-sell Bundles',
    description: 'Products that can be bundled optimized for upsell',
    allowedScopes: ['marketingChannels'],
  },
  deepAiRecommendedForYou: {
    name: 'Deep AI - Recommended for You',
    description: 'Personalized recommendations based on the latest algorithm',
    allowedScopes: ['marketingChannels'],
    hiddenOutsideReleva: true,
  },
  gatewayProducts: {
    name: 'Gateway Products',
    description: 'Products which are likely to be purchased by repeat customers.',
    allowedScopes: ['ads'],
  },
  searchEngineReferrer: {
    name: 'Search Engine Referrer',
    description: 'Products most viewed by users coming from search engines',
  },
  socialMediaReferrer: {
    name: 'Social Media Referrer',
    description: 'Products most viewed by users coming from social media',
  },
};

export default Algorithms;
